import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import moment from 'moment';
import AmpTable, {defaultTrProps} from './Table';
import makeTimeDateCell from '../atoms/makeTimeDateCell';
import Loading from '../molecules/Loading';
import ErrorPage from '../pages/ErrorPage';
import {Query} from '@apollo/react-components';
import gql from 'graphql-tag';
import {withErrorBoundary} from '../molecules/ErrorBoundary';
import makeDurationCell from '../atoms/makeDurationCell';

const columns = [
  {
    Header: 'START',
    accessor: 'start',
    Cell: makeTimeDateCell('start'),
  },
  {
    Header: 'END',
    accessor: 'end',
    Cell: makeTimeDateCell('end'),
  },
  {
    Header: 'Duration',
    accessor: 'duration',
    Cell: makeDurationCell('duration')
  },
];

export const GET_TRANSFER_HISTORY = gql`
  query System($id: ID!) {
    system(id: $id) {
      id
      transferHistory {
        start
        end
      }
    }
  }
`;

export const TransferHistoryTable = ({data}) => {
  return (
    <AmpTable
      data={data}
      style={{flex: 1, height: '100%'}}
      columns={columns}
      getTrProps={() => ({
        ...defaultTrProps,
        clickable: false,
      })}
      defaultSorted={[{id: 'start', desc: true}]}
    />
  );
};

TransferHistoryTable.propTypes = {
  data: PropTypes.array
};

const TransferHistory = ({match}) => {
  const {params: {id}} = match;
  return (
    <Query query={GET_TRANSFER_HISTORY} variables={{id}}>
      {({loading, error, data}) => {
        if (error) {
          return <ErrorPage error={error} />;
        }
        if (loading) {
          return <Loading loading={loading} message="Fetching transfer data..."/>;
        }
        const {system: {transferHistory}} = data;
        const withDuration = transferHistory.map(transfer => ({
          ...transfer,
          duration: moment(transfer.end).diff(moment(transfer.start))
        }));
        return <TransferHistoryTable data={withDuration}/>;
      }}
    </Query>
  );
};

TransferHistory.propTypes = {
  match: PropTypes.object
};

export default withErrorBoundary(withRouter(TransferHistory));

